import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {BrandSiteConfiguration} from '../../../services/configurations/config-data-sections/header.configuration';
import {Link} from '../../raw-components/link/link';
import {observer} from 'mobx-react';
import {SideMenuCrossBrandsListBox} from "./boxes/side-menu-cross-brands-list.box";
import {SideMenuCrossBrandsListItemBox} from "./boxes/side-menu-cross-brands-list-item.box";
import {SideMenuCrossBrandsListItemIconBox} from "./boxes/side-menu-cross-brands-list-item-icon.box";
import classNames from 'classnames';
import {CyClass} from "../../../../common/cy-classes";

export interface SideMenuCrossBrandsComponentProps {
  brands: BrandSiteConfiguration[];
  className?: string;
}

export const SideMenuCrossBrandsComponent = observer(class BrandListComponent extends OrbitComponent<SideMenuCrossBrandsComponentProps> {

  private _onBrandClick = async (brandConfig: BrandSiteConfiguration) => {
    this.services.analytics.sendOrbitUserFlowEvent("Navigation","Cross_Brand", brandConfig.text);
    await this.services.linksNavigation.navigateLink({
      linkId: brandConfig.linkId,
      marketingParams: {
        dl: brandConfig.dl
      }
    });
  };

  private _renderBrand(brandUIConfig: BrandSiteConfiguration) {
    if(!brandUIConfig.display) {
      return null;
    }

    const url = this.services.linksNavigation.getLinkUrl(brandUIConfig.linkId);


    return (
      <SideMenuCrossBrandsListItemBox key={brandUIConfig.linkId} className='cy-brand-switch-list-item'>
        <Link href={url} onClick={() => this._onBrandClick(brandUIConfig)} >
          <SideMenuCrossBrandsListItemIconBox linkId={brandUIConfig.linkId}/>
          {this.services.translation.translate(brandUIConfig.text)}
        </Link>
      </SideMenuCrossBrandsListItemBox>
    );
  }

  render() {
    return (
      <SideMenuCrossBrandsListBox className={classNames(this.props.className, CyClass('cy-brand-switch-list'))}>
        {this.props.brands.map(brand => this._renderBrand(brand))}
      </SideMenuCrossBrandsListBox>
    )
  }
});
